<template>
    <TreatmentCustomerTable :userId="userId" />
</template>

<script>
import TreatmentCustomerTable from './TreatmentCustomerTable.vue'

export default {
    props: {
        userId: {
            type: [Number, String, null],
            required: false,
            default: null,
        },
    },
    components: {
        TreatmentCustomerTable,
    },
}
</script>
